import styled from '@emotion/styled'

export const NavContainer = styled.div`
  box-sizing: unset;
  width: 100px;
  filter: drop-shadow(0 0 5px rgba(31, 31, 31, 0.1));
  position: fixed;
  right: 0;
  height: 50%;
  top: 25%;
  padding: 15px 0;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  background-color: #fff;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 25px;
  justify-content: space-between;
`

export const NavSlot = styled.div`
  flex-basis: 15%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const NavLink = styled.a`
  width: 50px;
  height: 50px;
  align-items: center;
  border-radius: 50rem;
  padding: 0.5rem 0.5rem;
  transition: 0.3s all;
  box-sizing: unset;
  
  &:hover {
    transition: 0.3s all;
    background: rgba(0, 0, 0, 0.11);
    color: #005cdb;
  }
`

export const MenuImg = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 25px;
`
